import { mapCatalogue } from '../utils/mapCatalogue';
import { getCatalogue } from './getCatalogue';
import { initSession } from './getSessionId';
import { setStorageItem } from './storage/session-storage/sessionStorage.service';

export async function preloader() {
  const { VITE_BRAND_CODE } = import.meta.env;
  try {
    await initSession();
    const catalogue = await getCatalogue(VITE_BRAND_CODE);
    setStorageItem('catalogue', mapCatalogue(catalogue));
    console.info('Catalogue preloaded:', catalogue.length, 'items');
  } catch (e) {
    console.warn('Failed to initialize session or preload catalogue', e);
  }
}
